import React, { useState } from "react";
import ContactButton from "./contactbutton";
import Terminal from "./terminal";

const MessageForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    organization: "",
    email: "",
    phone: "",
    message: "",
  });

  const [message, setMessage] = useState("");

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);
  const hasValue = (value) => value.trim() !== "";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, organization, email, phone, message } = formData;

    const emailValid = validateEmail(email);
    const nameValid = hasValue(name);
    const messageValid = hasValue(message);

    if (emailValid && nameValid && messageValid) {
      const data = {
        name: name,
        company: organization,
        email: email,
        phone: phone,
        message: message
      };

      try {
        await fetch("https://api.dev.acebit.se/contact/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
        setMessage("Ditt meddelande har skickats!");
      } catch (error) {
        setMessage("Ett fel inträffade när meddelandet skickades.\n\nFörsök igen senare.");
      }
    } else {
      setMessage("Ditt meddelande har inte skickats.\n\nSäkerställ att de obligatoriska fälten är ifyllda korrekt.");
    }
  };

  return (
    <div className="sm:w-4/5 w-full">
      <Terminal title="contact">
        {message ? <div className="flex">{message}</div> :
          <form id="contact-form" className="flex flex-col gap-2" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Namn"
              value={formData.name}
              onChange={handleChange}
              required
              className="p-2 dark:bg-gray-800 bg-slate-300 autofill:bg-gray-800"
            />
            <input
              type="text"
              name="organization"
              placeholder="Företag"
              value={formData.organization}
              onChange={handleChange}
              className="p-2 dark:bg-gray-800 bg-slate-300"
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
              className="p-2 dark:bg-gray-800 bg-slate-300"
            />
            <input
              type="text"
              name="phone"
              placeholder="Telefon"
              value={formData.phone}
              onChange={handleChange}
              className="p-2 dark:bg-gray-800 bg-slate-300"
            />
            <textarea
              name="message"
              placeholder="Meddelande"
              value={formData.message}
              onChange={handleChange}
              required
              className="min-h-28 resize-none p-2 dark:bg-gray-800 bg-slate-300"
            />
            <div className="w-full">
              <button type="submit" className="text-black bg-sky-500 hover:bg-sky-700 focus:ring-4 w-full min-w-10 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-sky-500 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
                Skicka
              </button>
            </div>
          </form>
        }
      </Terminal>
    </div>
  );
};


export default MessageForm;